/* ABRSM header shell, mobile search, localization, and responsive navigation runtime */
(function(){
  var responsiveRuntimeLoads = {};

  function loadResponsiveRuntime(name, url, initializerName, root){
    var initializer = window[initializerName];
    if(typeof initializer === 'function'){
      initializer(root);
      return;
    }
    if(!url) return;

    if(!responsiveRuntimeLoads[name]){
      responsiveRuntimeLoads[name] = new Promise(function(resolve, reject){
        var script = document.createElement('script');
        script.src = url;
        script.async = true;
        script.setAttribute('data-abrsm-responsive-runtime', name);
        script.addEventListener('load', resolve, { once: true });
        script.addEventListener('error', reject, { once: true });
        document.head.appendChild(script);
      }).catch(function(){
        var failedScript = document.querySelector('script[data-abrsm-responsive-runtime="' + name + '"]');
        if(failedScript) failedScript.remove();
        delete responsiveRuntimeLoads[name];
      });
    }

    responsiveRuntimeLoads[name].then(function(){
      var lateInitializer = window[initializerName];
      if(typeof lateInitializer === 'function') lateInitializer(root);
    });
  }

  function initHeaderShell(root){
  if(!root || root.dataset.headerShellInitialized === 'true') return;
  root.dataset.headerShellInitialized = 'true';

  var config = root.dataset;
  var sectionId = config.sectionId || '';
  var headerEl = root.querySelector('.site-header');
  var stickyWrapper = root.querySelector('.header-sticky-wrapper');
  var stickyEnabled = false;
  if (stickyWrapper) {
    var attr = stickyWrapper.getAttribute('data-sticky');
    if (attr && String(attr).toLowerCase() === 'true') { stickyEnabled = true; }
  }

  var observers = [];
  var cleanups = [];
  var stickySpacer = null;

  var desktopRuntimeQuery = window.matchMedia ? window.matchMedia('(min-width: 990px)') : null;
  function ensureResponsiveRuntimes(){
    var isDesktop = !desktopRuntimeQuery || desktopRuntimeQuery.matches;
    if(isDesktop || config.headerSearchRuntimeMobile === 'true'){
      loadResponsiveRuntime(
        'header-search',
        config.headerSearchRuntimeUrl,
        '__abrsmInitHeaderSearches',
        root
      );
    }
    if(isDesktop){
      loadResponsiveRuntime(
        'desktop-nav',
        config.desktopNavRuntimeUrl,
        '__abrsmInitDesktopNavs',
        root
      );
    }
  }

  ensureResponsiveRuntimes();
  if(desktopRuntimeQuery){
    if(typeof desktopRuntimeQuery.addEventListener === 'function'){
      desktopRuntimeQuery.addEventListener('change', ensureResponsiveRuntimes);
      cleanups.push(function(){ desktopRuntimeQuery.removeEventListener('change', ensureResponsiveRuntimes); });
    } else if(typeof desktopRuntimeQuery.addListener === 'function'){
      desktopRuntimeQuery.addListener(ensureResponsiveRuntimes);
      cleanups.push(function(){ desktopRuntimeQuery.removeListener(ensureResponsiveRuntimes); });
    }
  }

  /* Sticky: IO-based stuck state + robust fallback (zero CLS) */
  function ensureSpacer(){
    if (!stickySpacer) {
      stickySpacer = document.createElement('div');
      stickySpacer.setAttribute('data-sticky-spacer', 'true');
      stickySpacer.style.height = '0px';
      stickySpacer.style.pointerEvents = 'none';
      if (stickyWrapper && stickyWrapper.firstChild) {
        stickyWrapper.insertBefore(stickySpacer, stickyWrapper.firstChild);
      } else if (stickyWrapper) {
        stickyWrapper.appendChild(stickySpacer);
      }
    }
  }

  if (stickyEnabled && headerEl && stickyWrapper) {
    var stickySentinel = root.querySelector('.io-sentinel--sticky');

    var stickyObs = new IntersectionObserver(function(entries){
      var entry = entries[0];
      var stuck = !entry.isIntersecting;
      headerEl.classList.toggle('is-stuck', stuck);

      /* Fixed fallback if sticky ineffective (e.g. ancestor constraints) */
      var computedSticky = '';
      try { computedSticky = window.getComputedStyle(stickyWrapper).position; } catch(_e){}
      var supportsSticky = (computedSticky.indexOf('sticky') !== -1);
      var needFixedFallback = false;

      if (stuck) {
        var topNow = headerEl.getBoundingClientRect().top;
        if (!supportsSticky || Math.abs(topNow) > 1) {
          needFixedFallback = true;
        }
      }

      if (needFixedFallback) {
        ensureSpacer();
        var h = headerEl.getBoundingClientRect().height;
        stickySpacer.style.height = h + 'px';
        headerEl.style.position = 'fixed';
        headerEl.style.top = '0';
        headerEl.style.left = '0';
        headerEl.style.right = '0';
        headerEl.style.width = '100%';
      } else {
        headerEl.style.position = '';
        headerEl.style.top = '';
        headerEl.style.left = '';
        headerEl.style.right = '';
        headerEl.style.width = '';
        if (stickySpacer) stickySpacer.style.height = '0px';
      }
    }, { rootMargin: "0px 0px 0px 0px", threshold: [0, 1] });

    if (stickySentinel) {
      stickyObs.observe(stickySentinel);
      observers.push(stickyObs);
    }

    function onStickyResize(){
      if (stickySpacer && headerEl && headerEl.style.position === 'fixed') {
        stickySpacer.style.height = headerEl.getBoundingClientRect().height + 'px';
      }
    }
    window.addEventListener('resize', onStickyResize, { passive: true });
    cleanups.push(function(){ try { window.removeEventListener('resize', onStickyResize); } catch(_e){} });
  }

  /* Inline Localization controller */
  var locPanel = root.querySelector('#LocPanel-' + sectionId);
  var locBtn   = root.querySelector('.abrsm-site-nav-icons .abrsm-country');
  if (locPanel && locBtn) {
    function isOpen(){ return locPanel.getAttribute('aria-hidden') === 'false'; }
    function setLoc(open){
      locPanel.setAttribute('aria-hidden', open ? 'false' : 'true');
      locBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        var firstFocusable = locPanel.querySelector('select, button');
        if (firstFocusable) { firstFocusable.focus({ preventScroll: true }); }
      } else {
        try { locBtn.focus({ preventScroll: true }); } catch(e){}
      }
    }
    function onToggleLocalization(){ setLoc(!isOpen()); }
    function onOpenLocalization(){ setLoc(true); }
    function onLocalizationDocumentClick(e){
      if(isOpen() && !locPanel.contains(e.target) && !locBtn.contains(e.target)){ setLoc(false); }
    }
    function onLocalizationKeydown(e){
      if(e.key === 'Escape' && isOpen()){ setLoc(false); }
    }
    root.addEventListener('abrsm:toggle-localization', onToggleLocalization);
    root.addEventListener('abrsm:open-localization', onOpenLocalization);
    document.addEventListener('click', onLocalizationDocumentClick);
    document.addEventListener('keydown', onLocalizationKeydown);
    cleanups.push(function(){
      try { root.removeEventListener('abrsm:toggle-localization', onToggleLocalization); } catch(_e){}
      try { root.removeEventListener('abrsm:open-localization', onOpenLocalization); } catch(_e){}
      try { document.removeEventListener('click', onLocalizationDocumentClick); } catch(_e){}
      try { document.removeEventListener('keydown', onLocalizationKeydown); } catch(_e){}
    });
  }

  /* Mobile search overlay: intercept search icon tap and open a real input (prevents empty /search navigation) */
  var mSearch = root.querySelector('#MSearch-' + sectionId);
  if (mSearch) {
    var mForm = mSearch.querySelector('form');
    var mInput = mSearch.querySelector('.abrsm-msearch__input');
    var mSuggest = mSearch.querySelector('[data-msearch-suggest]');
    var mSuggestList = mSearch.querySelector('[data-msearch-suggest-list]');
    var mSuggestCount = mSearch.querySelector('[data-msearch-suggest-count]');
    var mViewAll = mSearch.querySelector('[data-msearch-view-all]');
    var mStarter = mSearch.querySelector('[data-msearch-starter]');
    var allProductsUrl = config.allProductsUrl || '/collections/all';
    var mSearchUrl = config.searchUrl || '/search';
    var mDigitalDownloadsIndexUrl = config.digitalDownloadsIndexUrl || '';

    if (mForm && mInput) {
      mForm.addEventListener('submit', function(e){
        var q = (mInput.value || '').trim();
        if (!q) {
          e.preventDefault();
          window.location.assign(allProductsUrl);
        }
      });
    }

    var prevHtmlOverflow = '';
    var prevBodyOverflow = '';

    function isMobile(){ return window.matchMedia('(max-width: 989px)').matches; }
    function msIsOpen(){ return mSearch.getAttribute('aria-hidden') === 'false'; }

    function lockScroll(lock){
      if (lock) {
        prevHtmlOverflow = document.documentElement.style.overflow || '';
        prevBodyOverflow = document.body.style.overflow || '';
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
      } else {
        document.documentElement.style.overflow = prevHtmlOverflow;
        document.body.style.overflow = prevBodyOverflow;
      }
    }

    var mSearchCache = {};
    var mSearchRequestId = 0;

    function escapeMSearchHtml(value) {
      return String(value == null ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function normalizeMSearch(value) {
      return String(value == null ? '' : value)
        .toLowerCase()
        .replace(/&/g, ' and ')
        .replace(/[^a-z0-9]+/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
    }

    function getMSearchHandle(product) {
      if (product && product.handle) return String(product.handle).toLowerCase();

      try {
        var path = new URL(product && product.url ? product.url : '', window.location.origin).pathname;
        var parts = path.split('/').filter(Boolean);
        return parts.length ? String(parts[parts.length - 1]).toLowerCase() : '';
      } catch (_error) {
        return '';
      }
    }

    function formatMSearchMoney(value, valueIsCents) {
      if (typeof value === 'string' && value.indexOf('£') > -1) return value;
      if (value == null || value === '') return '';

      var amount = Number(value);
      if (!Number.isFinite(amount) || amount <= 0) return '';
      if (valueIsCents) amount = amount / 100;

      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
          style: 'currency',
          currency: config.currencyCode || 'GBP',
          minimumFractionDigits: Math.abs(amount - Math.round(amount)) > 0.001 ? 2 : 0,
          maximumFractionDigits: Math.abs(amount - Math.round(amount)) > 0.001 ? 2 : 0
        }).format(amount);
      } catch (_error) {
        return '£' + amount.toFixed(Math.abs(amount - Math.round(amount)) > 0.001 ? 2 : 0);
      }
    }

    function loadMSearchDigitalDownloadsIndex() {
      if (!mDigitalDownloadsIndexUrl) return Promise.resolve(null);
      if (window.__abrsmDigitalDownloadsIndexPromise) return window.__abrsmDigitalDownloadsIndexPromise;

      window.__abrsmDigitalDownloadsIndexPromise = fetch(mDigitalDownloadsIndexUrl, { credentials: 'same-origin' })
        .then(function(response) {
          return response.ok ? response.json() : null;
        })
        .catch(function() {
          return null;
        });

      return window.__abrsmDigitalDownloadsIndexPromise;
    }

    function scoreMSearchDigitalProduct(product, query) {
      var queryKey = normalizeMSearch(query);
      if (!queryKey || queryKey.length < 3) return 0;

      var fields = [
        product && product.title,
        product && product.handle,
        product && product.product_type,
        product && product.vendor
      ];

      ['tags', 'instruments', 'grades', 'search_terms'].forEach(function(key) {
        if (Array.isArray(product && product[key])) fields = fields.concat(product[key]);
      });

      if (Array.isArray(product && product.pieces)) {
        product.pieces.forEach(function(piece) {
          fields.push(piece && piece.title);
          fields.push(piece && piece.composer);
          fields.push(piece && piece.source_publication);
        });
      }

      var haystack = normalizeMSearch(fields.filter(Boolean).join(' '));
      if (!haystack) return 0;

      if (normalizeMSearch(product && product.title) === queryKey) return 150;
      if (haystack.indexOf(queryKey) > -1) return 125;

      var requestedGradeMatch = queryKey.match(/(?:grade|level) (initial|[1-8])(?: |$)/);
      var requestedGrade = requestedGradeMatch ? requestedGradeMatch[1] : '';
      var productGrades = Array.isArray(product && product.grades)
        ? product.grades.map(function(grade) { return normalizeMSearch(grade).replace(/^grade /, ''); })
        : [];

      if (requestedGrade && productGrades.length && productGrades.indexOf(requestedGrade) === -1) {
        return 0;
      }

      var terms = queryKey.split(' ').filter(function(term) {
        return term && ['a', 'an', 'and', 'for', 'from', 'in', 'of', 'on', 'the', 'to'].indexOf(term) === -1;
      });
      var matches = terms.filter(function(term) {
        var escapedTerm = term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        return new RegExp('(?:^| )' + escapedTerm + '(?: |$)').test(haystack);
      }).length;

      if (matches < Math.min(terms.length, 2)) return 0;

      return 90 + matches * 5 + (requestedGrade && productGrades.indexOf(requestedGrade) > -1 ? 12 : 0);
    }

    function findMSearchDigitalMatches(index, query) {
      var products = index && Array.isArray(index.products) ? index.products : [];
      return products
        .map(function(product) {
          var score = scoreMSearchDigitalProduct(product, query);
          if (!score) return null;

          return {
            handle: product.handle || '',
            title: product.title || '',
            url: product.url || '/products/' + String(product.handle || ''),
            product_type: product.product_type || 'Digital Sheet Music',
            image: product.image || '',
            price: Number(product.price || 0),
            price_is_cents: true,
            match_source: 'digital-downloads',
            match_score: score
          };
        })
        .filter(Boolean)
        .sort(function(left, right) {
          return Number(right.match_score || 0) - Number(left.match_score || 0);
        })
        .slice(0, 4);
    }

    function fetchMSearchProducts(query) {
      var params = new URLSearchParams();
      params.set('q', query);
      params.set('resources[type]', 'product');
      params.set('resources[limit]', '4');
      params.set('resources[limit_scope]', 'each');
      params.set('resources[options][unavailable_products]', config.unavailableProducts || 'last');
      params.set('resources[options][fields]', 'title,product_type,vendor,variants.sku,tag');

      return fetch('/search/suggest.json?' + params.toString(), { credentials: 'same-origin' })
        .then(function(response) {
          return response.ok ? response.json() : { resources: { results: { products: [] } } };
        })
        .then(function(data) {
          return data && data.resources && data.resources.results && Array.isArray(data.resources.results.products)
            ? data.resources.results.products
            : [];
        })
        .catch(function() {
          return [];
        });
    }

    function clearMSearchSuggestions() {
      if (mSuggest) mSuggest.hidden = true;
      if (mSuggestList) mSuggestList.innerHTML = '';
      if (mSuggestCount) mSuggestCount.textContent = '';
      if (mStarter) mStarter.hidden = false;
      if (mInput) mInput.setAttribute('aria-expanded', 'false');
    }

    function getMSearchImage(product) {
      var image = product && product.image ? product.image : product && product.featured_image ? product.featured_image : '';
      if (image && typeof image === 'object') image = image.url || image.src || '';
      image = String(image || '').trim();

      if (!image || (!/^https?:\/\//i.test(image) && image.charAt(0) !== '/')) return '';

      if (/cdn\.shopify\.com/i.test(image)) {
        image += image.indexOf('?') > -1 ? '&width=96' : '?width=96';
      }

      return image;
    }

    function renderMSearchSuggestions(items, query) {
      if (!mSuggest || !mSuggestList) return;

      if (!items.length) {
        clearMSearchSuggestions();
        return;
      }

      mSuggestList.innerHTML = items.map(function(product) {
        var isDigital = product.match_source === 'digital-downloads';
        var priceValue = product.price_min || product.price || product.price_max || '';
        var price = formatMSearchMoney(priceValue, product.price_is_cents === true || isDigital);
        var meta = isDigital ? '<span class="abrsm-msearch__suggest-badge">Instant download</span>' : escapeMSearchHtml(product.product_type || product.type || 'Product');
        var image = getMSearchImage(product);
        var media = image
          ? '<span class="abrsm-msearch__suggest-media"><img src="' + escapeMSearchHtml(image) + '" alt="" width="48" height="64" loading="lazy"></span>'
          : '<span class="abrsm-msearch__suggest-media abrsm-msearch__suggest-media--empty" aria-hidden="true"></span>';

        return '<a class="abrsm-msearch__suggest-link" href="' + escapeMSearchHtml(product.url || mSearchUrl) + '">'
          + media
          + '<span class="abrsm-msearch__suggest-name">' + escapeMSearchHtml(product.title || '') + '</span>'
          + (price ? '<span class="abrsm-msearch__suggest-price">' + escapeMSearchHtml(price) + '</span>' : '')
          + '<span class="abrsm-msearch__suggest-meta">' + meta + '</span>'
          + '</a>';
      }).join('');

      if (mSuggestCount) {
        mSuggestCount.textContent = items.length === 1 ? '1 match' : items.length + ' matches';
      }

      if (mViewAll) {
        mViewAll.href = mSearchUrl + '?q=' + encodeURIComponent(query);
      }

      if (mStarter) mStarter.hidden = true;
      if (mInput) mInput.setAttribute('aria-expanded', 'true');
      mSuggest.hidden = false;
    }

    function mergeMSearchProducts(nativeProducts, digitalProducts) {
      var seenHandles = {};
      var merged = [];

      nativeProducts.concat(digitalProducts).forEach(function(product) {
        var handle = getMSearchHandle(product);
        var key = handle || String(product && product.url ? product.url : product && product.title ? product.title : '').toLowerCase();
        if (!key || seenHandles[key]) return;
        seenHandles[key] = true;
        merged.push(product);
      });

      return merged.slice(0, 5);
    }

    function updateMSearchSuggestions(query) {
      query = (query || '').trim();
      mSearchRequestId += 1;
      var requestId = mSearchRequestId;

      if (!query || query.length < 2) {
        clearMSearchSuggestions();
        return;
      }

      var cacheKey = query.toLowerCase();
      if (mSearchCache[cacheKey]) {
        renderMSearchSuggestions(mSearchCache[cacheKey], query);
        return;
      }

      Promise.all([
        fetchMSearchProducts(query),
        loadMSearchDigitalDownloadsIndex()
      ]).then(function(values) {
        if (requestId !== mSearchRequestId) return;

        var nativeProducts = values[0] || [];
        var digitalProducts = findMSearchDigitalMatches(values[1], query);
        var merged = mergeMSearchProducts(nativeProducts, digitalProducts);
        mSearchCache[cacheKey] = merged;
        renderMSearchSuggestions(merged, query);
      });
    }

    function debounceMSearch(fn, wait) {
      var timeoutId = null;
      return function() {
        var args = arguments;
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(function() {
          fn.apply(null, args);
        }, wait || 180);
      };
    }

    var updateMSearchSuggestionsDebounced = debounceMSearch(updateMSearchSuggestions, 180);
    var mPreviousFocus = null;

    function getMSearchFocusableElements() {
      return Array.prototype.slice.call(mSearch.querySelectorAll('a[href], button:not([disabled]), input:not([disabled])'))
        .filter(function(element) {
          return !element.hidden && element.getClientRects().length > 0;
        });
    }

    function openSearch(){
      mPreviousFocus = document.activeElement;
      mSearch.setAttribute('aria-hidden', 'false');
      document.body.classList.add('abrsm-mobile-search-open');
      lockScroll(true);
      clearMSearchSuggestions();
      document.dispatchEvent(new CustomEvent('abrsm-mobile-search:open'));
      if (mInput) {
        mInput.value = '';
        try { mInput.focus({ preventScroll: true }); } catch(_e){ mInput.focus(); }
      }
    }

    function closeSearch(){
      if (!msIsOpen()) return;
      mSearch.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('abrsm-mobile-search-open');
      lockScroll(false);
      mSearchRequestId += 1;
      clearMSearchSuggestions();
      document.dispatchEvent(new CustomEvent('abrsm-mobile-search:close'));
      if (mPreviousFocus && document.documentElement.contains(mPreviousFocus)) {
        try { mPreviousFocus.focus({ preventScroll: true }); } catch(_e){ mPreviousFocus.focus(); }
      }
      mPreviousFocus = null;
    }

    function onOverlayClick(e){
      var t = e.target;
      if (t && t.hasAttribute && t.hasAttribute('data-msearch-close')) closeSearch();
    }
    mSearch.addEventListener('click', onOverlayClick);
    cleanups.push(function(){ try { mSearch.removeEventListener('click', onOverlayClick); } catch(_e){} });

    function onDocKeydown(e){
      if (!msIsOpen()) return;

      if (e.key === 'Escape') {
        closeSearch();
        return;
      }

      if (e.key !== 'Tab') return;

      var focusableElements = getMSearchFocusableElements();
      if (!focusableElements.length) return;

      var firstFocusable = focusableElements[0];
      var lastFocusable = focusableElements[focusableElements.length - 1];
      if (e.shiftKey && document.activeElement === firstFocusable) {
        e.preventDefault();
        lastFocusable.focus();
      } else if (!e.shiftKey && document.activeElement === lastFocusable) {
        e.preventDefault();
        firstFocusable.focus();
      }
    }
    document.addEventListener('keydown', onDocKeydown);
    cleanups.push(function(){ try { document.removeEventListener('keydown', onDocKeydown); } catch(_e){} });

    function onMSearchInput(event){
      updateMSearchSuggestionsDebounced(event && event.target ? event.target.value : '');
    }
    if (mInput) {
      mInput.addEventListener('input', onMSearchInput);
      cleanups.push(function(){ try { mInput.removeEventListener('input', onMSearchInput); } catch(_e){} });
    }

    function onRootClickCapture(e){
      if (!isMobile()) return;

      var t = e.target;
      if (!t || !t.closest) return;

      var icons = t.closest('.abrsm-site-nav-icons');
      if (!icons) return;

      var a = t.closest('a[href]');
      var b = t.closest('button');

      var label = '';
      if (a) label = (a.getAttribute('aria-label') || a.getAttribute('title') || '');
      if (b && !label) label = (b.getAttribute('aria-label') || b.getAttribute('title') || '');

      var href = a ? (a.getAttribute('href') || '') : '';
      var looksLikeSearchLink = href && (href.indexOf('/search') !== -1);
      var looksLikeSearchButton = /search/i.test(label);

      if (looksLikeSearchLink || looksLikeSearchButton) {
        e.preventDefault();
        e.stopPropagation();
        openSearch();
      }
    }
    root.addEventListener('click', onRootClickCapture, true);
    cleanups.push(function(){ try { root.removeEventListener('click', onRootClickCapture, true); } catch(_e){} });

    cleanups.push(function(){
      try { closeSearch(); } catch(_e){}
    });
  }

  /* Pass runtime nav attributes expected by the upgraded nav snippet */
  var nav = root.querySelector('.abrsm-desktop-nav') || root.querySelector('.site-nav');
  if (nav){
    nav.setAttribute('data-delay', config.navHoverDelay || '110');
    nav.setAttribute('data-threshold', config.navMegaThreshold || '8');
    nav.setAttribute('data-cols', config.navMegaColumns || '4');
    nav.setAttribute('data-img-mode', config.navMegaImageMode || 'thumbnail');
    nav.setAttribute('data-grid', config.navMegaGrid || 'auto');
  }

  var navShell = root.querySelector('.abrsm-nav');
  var navMeasure = navShell && (navShell.querySelector('.abrsm-desktop-nav') || navShell.querySelector('.site-nav'));
  var navCollapseFrame = 0;
  var navLastMeasuredWidth = 0;
  var responsiveCollapseViewport = Math.max(Number(config.navCollapseViewport || 1050), 1180);

  function getAvailableNavWidth(){
    if (!navShell) return 0;

    var shellWidth = navShell.clientWidth || Math.floor(navShell.getBoundingClientRect().width || 0);

    if (!shellWidth && navShell.parentElement) {
      shellWidth = Math.floor(navShell.parentElement.getBoundingClientRect().width || 0);
    }

    return Math.max(0, Math.floor(shellWidth));
  }

  function getMeasuredNavWidth(){
    if (!navMeasure) return 0;

    var measuredWidth = Math.ceil(navMeasure.scrollWidth || navMeasure.getBoundingClientRect().width || 0);
    if (measuredWidth) {
      navLastMeasuredWidth = measuredWidth;
    }

    return measuredWidth || navLastMeasuredWidth;
  }

  function syncResponsiveNavCollapse(){
    navCollapseFrame = 0;

    if (!navShell || !navMeasure) {
      root.classList.remove('abrsm-header--nav-collapsed');
      return;
    }

    var viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;
    if (viewportWidth < 990) {
      root.classList.remove('abrsm-header--nav-collapsed');
      return;
    }

    if (viewportWidth <= responsiveCollapseViewport) {
      root.classList.add('abrsm-header--nav-collapsed');
      return;
    }

    var shellWidth = getAvailableNavWidth();
    var menuWidth = getMeasuredNavWidth();
    if (!shellWidth || !menuWidth) {
      root.classList.remove('abrsm-header--nav-collapsed');
      return;
    }

    var isCollapsed = root.classList.contains('abrsm-header--nav-collapsed');
    var collapseThreshold = shellWidth - 36;
    var expandThreshold = shellWidth - 96;
    root.classList.toggle(
      'abrsm-header--nav-collapsed',
      isCollapsed ? menuWidth > expandThreshold : menuWidth > collapseThreshold
    );
  }

  function scheduleResponsiveNavCollapse(){
    if (navCollapseFrame) return;
    navCollapseFrame = window.requestAnimationFrame(syncResponsiveNavCollapse);
  }

  scheduleResponsiveNavCollapse();
  var navCollapseTimers = [
    window.setTimeout(scheduleResponsiveNavCollapse, 400),
    window.setTimeout(scheduleResponsiveNavCollapse, 1400)
  ];
  window.addEventListener('resize', scheduleResponsiveNavCollapse);
  cleanups.push(function(){
    navCollapseTimers.forEach(function(timer){
      try { window.clearTimeout(timer); } catch(_e){}
    });
    try { window.removeEventListener('resize', scheduleResponsiveNavCollapse); } catch(_e){}
    if (navCollapseFrame) {
      try { window.cancelAnimationFrame(navCollapseFrame); } catch(_e){}
      navCollapseFrame = 0;
    }
  });

  if (document.fonts && document.fonts.ready && typeof document.fonts.ready.then === 'function') {
    document.fonts.ready.then(function(){
      scheduleResponsiveNavCollapse();
    }).catch(function(){});
  }

  if (window.ResizeObserver && navShell) {
    var navResizeObserver = new ResizeObserver(function(){
      scheduleResponsiveNavCollapse();
    });
    navResizeObserver.observe(navShell);
    if (navMeasure && navMeasure !== navShell) {
      navResizeObserver.observe(navMeasure);
    }
    observers.push(navResizeObserver);
  }

  root.__abrsmHeaderShellCleanup = function(){
    observers.forEach(function(observer){ try { observer.disconnect(); } catch(_e){} });
    observers = [];
    if (stickySpacer) {
      stickySpacer.remove();
      stickySpacer = null;
    }
    cleanups.forEach(function(cleanup){ try { cleanup(); } catch(_e){} });
    cleanups = [];
    root.removeAttribute('data-header-shell-initialized');
    root.__abrsmHeaderShellCleanup = null;
  };
  }

  function initAll(scope){
    if(!scope) return;
    if(scope.matches && scope.matches('.abrsm-header')) initHeaderShell(scope);
    if(scope.querySelectorAll){
      scope.querySelectorAll('.abrsm-header').forEach(initHeaderShell);
    }
  }

  function cleanupAll(scope){
    if(!scope) return;
    var roots = [];
    if(scope.matches && scope.matches('.abrsm-header')) roots.push(scope);
    if(scope.querySelectorAll){
      scope.querySelectorAll('.abrsm-header').forEach(function(root){ roots.push(root); });
    }
    roots.forEach(function(root){
      if(typeof root.__abrsmHeaderShellCleanup === 'function'){
        root.__abrsmHeaderShellCleanup();
      }
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function(event){
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function(event){
    cleanupAll(event.target);
  });
})();
